export default {
  SET_TRANSFERENCIAS(state, list) {
    state.listaTransferencias = list
  },
  RESET_TRANSFERENCIA(state) {
    state.transferencia = {
      id: null, contaOrigem: null, contaDestino: null, data: null, valor: 0, obs: '',
    }
  },
}
